













































import {Component, Vue} from "vue-property-decorator";
import {namespace} from "vuex-class";

const Auth = namespace("Auth");

@Component
export default class Login extends Vue {
    private user: any = {username: "", password: ""};

    dialogLogin = false;
    errorLoginAlert = '';
    validLogin = true;
    passwordRules = [(v: any) => !!v || 'Required password'];

    @Auth.Getter
    private isLoggedIn!: boolean;

    @Auth.Action
    private login!: (data: any) => Promise<any>;

    created() {
        if (this.isLoggedIn) {
            this.$router.push({name: "hildegard", params: {lang: this.$route.params.lang}});
        }
    }

    $refs!: {
        formLogin: HTMLFormElement
    }

    validateLogin() {
        if (this.$refs.formLogin.validate()) {
            this.login(this.user).then(
                () => {
                    this.$router.push({name: "hildegard", params: {lang: this.$route.params.lang}});
                },
                (error) => {
                    console.log(error);
                    this.errorLoginAlert = error
                }
            );
        }
    }
}
